import { Children, createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


const UserContext = createContext();

export const UserProvider = ({children}) => {

    const [details, setDetails] = useState(null);
    const [pending , setPending] = useState(true);

    const navigate = useNavigate();

    const userDetails = JSON.parse(window.localStorage.getItem('token'));

    const fetchUserDetails = async () => {
        // const userDetails = JSON.parse(localStorage.getItem("token"));
        setPending(true);
        let token = userDetails ? userDetails.token : null;
        try {
          const response = await fetch(
            `${process.env.REACT_APP_SERVER_BASE_URL}/api/users/details`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.status === 401) {
            alert("Session Expired, Please login again");
            localStorage.removeItem("token");
            navigate("/login");
          }

          if (response.status === 403) {
            alert("Your are not authorized to access this page");
            throw new Error("Non-Authorized Route Access Error");
          }

          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }

          const jsonData = await response.json();
          setDetails(jsonData)
          console.log(jsonData, "USER DETAILS");

        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setPending(false);
        }
      };

      useEffect( () => {
        fetchUserDetails();
      }, [])

    return (
        <UserContext.Provider value={{details, pending, setDetails, fetchUserDetails}}>
            {children}
        </UserContext.Provider>
    );
}

export default UserContext;